module.exports = __webpack_public_path__ + "img/115-unit.a769c6cc.png";